



























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class WalletOrder extends Vue {
  @Prop({ default: () => [] }) data: Array<any>;
  @Prop({ default: () => [] }) ddCodes: Array<any>;
  @Prop({ default: () => [] }) orderStatus: Array<any>; // 订单状态字典
  @Prop({ default: "01" }) status: string;
  @Prop({ default: false }) loading: boolean;

  get randomId() {
    return Date.now();
  }

  fFieldLabel(list, status, prop) {
    if (!list || !list.length) return;
    const obj = list.find(el => {
      return el[prop] === status;
    });
    return obj && obj.label;
  }

  fStatusStr(status) {
    const strMap = {
      "2": "已完成",
      "1": "审核中"
    };
    return strMap[String(parseInt(status))];
  }
}
